export default "__VITE_ASSET__rDD_iaA4__"